
  export const style={
    inpuStyle:{
      colorInput:"#283A97"
    },
    url:{
      urlClient:"https://cury.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_cury.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"BlocoCoin/BlocosCoins"
    },
    teamName:{
      name:"Cury"
    },
    hasToken: true,
    hostHeader: "cury"
  }
